import { Container, HeaderTitle, SubmitButton, EventForm } from "./style";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import { FormDataSource } from "../../util/formDataSource";
import { Left, Right } from "./style";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import { addColleague, getColleague, updateColleague } from '../../api/colleaguesService';
import { ASSIGNABLE_ROLES } from "../../util/roles";

interface Props {
  inputs: FormDataSource[];
  actionMode: string;
}
export type IUploadStatus = "NO_IMAGE" | "UPLOADING" | "UPLOADED";

const NewColleague: React.FC<Props> = ({ inputs, actionMode }) => {

  const { id }: any = useParams();
  const [file, setFile] = useState<File | null>(null);
  const [uploadStatus, setUploadStatus] = useState<IUploadStatus>("NO_IMAGE");
  const [data, setData]: any = useState({
    timeStamp: new Date(),
    image: `uploads/images/noimage.png`,
    role: 'sales_manager',
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (actionMode == 'edit') {
      getColleague(id).then((item) => {
        setData({
          ...item,
          role: item.role || 'sales_manager',
        });
      }).catch((err) => {
        console.log('error', err.message);
      })
    }
  }, [actionMode, id]);

  useEffect(() => {
    if (file) {
      setData({
        ...data,
        image: file.name,
        file: file
      });
      setUploadStatus("UPLOADED");
    }
  }, [file]);

  const handleSubmit = async (e: React.FormEvent<HTMLElement>) => {
    e.preventDefault();
    try {
      if (actionMode === 'edit') {
        await updateColleague(data);
      } else {
        await addColleague(data);
      }
      navigate('/colleagues');
    } catch (error: any) {
      console.log(error.message);
    }
  };

  const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
      setUploadStatus("UPLOADING");
    } else {
      setUploadStatus("NO_IMAGE");
    }
  };

  const handleInput = (e: any) => {
    const fieldId = e.target.id;
    const value = e.target.value;
    if (actionMode == 'edit' && fieldId == 'email') return;
    setData({ ...data, [fieldId]: value });
  };

  return (
    <Layout>
      <HeaderTitle>{actionMode === 'edit' ? 'Edit Colleague' : 'Add New Colleague'}</HeaderTitle>
      <EventForm onSubmit={(e: any) => handleSubmit(e)}>
        <Container>
          <Left>
            <img
              src={
                file
                  ? URL.createObjectURL(file)
                  : `${process.env.REACT_APP_SERVER_URL}/api/${data.image}`
              }
              alt="img"
              className="img"
            />
            <div className="file">
              <p className="inputTitle">Upload Image:</p>
              <label htmlFor="file">
                <DriveFolderUploadIcon className="icon" />
              </label>
            </div>
            <input
              onChange={handleFile}
              name="img"
              style={{ display: "none" }}
              type="file"
              id="file"
            />
          </Left>
          <Right>
            <div>
              <div className="inputs">
                {inputs.map((input) => (
                  <div key={input.id} className="input">
                    <label className="inputTitle">{input.label}</label>
                    <br />
                    <input
                      onChange={handleInput}
                      id={input.id}
                      className="inputField"
                      type={input.type}
                      placeholder={input.placeholder}
                      value={data[input.id] || ''}
                      disabled={!input.label}
                    />
                  </div>
                ))}
                <div className="input">
                  <label className="inputTitle">Role</label>
                  <br />
                  <select
                    id="role"
                    className="inputField"
                    value={data.role || 'sales_manager'}
                    onChange={handleInput}
                  >
                    {ASSIGNABLE_ROLES.map((r) => (
                      <option key={r.value} value={r.value}>{r.label}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="button-container">
                {uploadStatus === "UPLOADING" ? (
                  <SubmitButton disabled type="submit">
                    Uploading...
                  </SubmitButton>
                ) : (
                  <SubmitButton type="submit">SUBMIT</SubmitButton>
                )}
              </div>
            </div>
          </Right>
        </Container>
      </EventForm>
    </Layout>
  );
};

export default NewColleague;
